import { Text } from '@ebh/capsule';
import { Tick, Close } from '@ebh/capsule/icons';
import styles from './styles';

interface PasswordRulesProps {
  password: string;
}

const PasswordRules = ({ password }: PasswordRulesProps) => {
  const isTouched = !!password;
  const rules = [
    {
      id: 'length',
      label: 'Password should be 8 to 15 characters long',
      test: (pw: string) => pw.length >= 8 && pw.length <= 15,
    },
    {
      id: 'letter',
      label: 'One uppercase and one lowercase letter',
      test: (pw: string) => /[A-Z]/.test(pw) && /[a-z]/.test(pw),
    },
    {
      id: 'number',
      label: 'At least one number character',
      test: (pw: string) => /[0-9]/.test(pw),
    },
    {
      id: 'special',
      label: 'At least one special character',
      test: (pw: string) => /[!@#$%^&*]/.test(pw),
    },
  ];

  const isValid = (rule: (typeof rules)[0]) => rule.test(password || '');

  return (
    <div css={styles.passwordRules}>
      {rules.map((rule) => {
        const valid = isValid(rule);

        if (!isTouched) {
          return (
            <div key={rule.id} css={styles.ruleItem}>
              <Tick color="gray-300" css={styles.ruleIcon} />
              <Text variant="body-2" color="gray-300">
                {rule.label}
              </Text>
            </div>
          );
        }

        return (
          <div key={rule.id} css={styles.ruleItem}>
            {valid ? (
              <>
                <Tick color="primary-500" css={styles.ruleIcon} />
                <Text variant="body-2" color="primary-500">
                  {rule.label}
                </Text>
              </>
            ) : (
              <>
                <Close color="error-400" css={styles.ruleIcon} />
                <Text variant="body-2" color="error-400">
                  {rule.label}
                </Text>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PasswordRules;
